(() => {
  const TITLE_SELECTOR = '[data-product-title-option]';
  const OPTION_SELECTOR =
    'input[data-option-name], select[data-option-name]';

  const normalise = (value) =>
    String(value || '').trim().toLowerCase();

  const findProductScope = (element) =>
    element?.closest(
      'product-information, .product-information, [data-product-id]'
    ) || document;

  const getSelectedValue = (scope, optionName) => {
    const fields = scope.querySelectorAll(OPTION_SELECTOR);

    for (const field of fields) {
      if (normalise(field.dataset.optionName) !== optionName) {
        continue;
      }

      if (field instanceof HTMLSelectElement) {
        return field.value;
      }

      if (field instanceof HTMLInputElement && field.checked) {
        return field.value;
      }
    }

    return '';
  };

  const updateTitle = (changedField = null) => {
    const scope = findProductScope(changedField);

    let outputs = scope.querySelectorAll(TITLE_SELECTOR);

    if (!outputs.length && scope !== document) {
      outputs = document.querySelectorAll(TITLE_SELECTOR);
    }

    outputs.forEach((output) => {
      const optionName = normalise(
        output.dataset.productTitleOption || 'Size'
      );

      let selectedValue = getSelectedValue(scope, optionName);

      if (!selectedValue && scope !== document) {
        selectedValue = getSelectedValue(document, optionName);
      }

      output.textContent = selectedValue;
    });
  };

  const handleOptionChange = (event) => {
    const field = event.target;

    if (
      !(field instanceof HTMLInputElement) &&
      !(field instanceof HTMLSelectElement)
    ) {
      return;
    }

    if (!field.matches(OPTION_SELECTOR)) {
      return;
    }

    /*
     * Let Horizon finish updating the selected radio and variant first.
     */
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        updateTitle(field);
      });
    });
  };

  document.addEventListener('change', handleOptionChange);

  /*
   * Some Horizon picker interactions update state during click handling,
   * so this provides a fallback for pill-style radio buttons.
   */
  document.addEventListener('click', (event) => {
    const label = event.target.closest('.variant-option__button-label');

    if (!label) {
      return;
    }

    const field = label.querySelector('input[data-option-name]');

    if (!field) {
      return;
    }

    setTimeout(() => {
      updateTitle(field);
    }, 0);
  });

  document.addEventListener('DOMContentLoaded', () => {
    updateTitle();
  });

  document.addEventListener('shopify:section:load', (event) => {
    const field = event.target.querySelector(OPTION_SELECTOR);
    updateTitle(field);
  });
})();